<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep-bot"><span class="epub-i">Après moi, le déluge</span>—“After me, disaster”</p>
<p class="epc">—The caption Andrew Cunanan chose for his high school yearbook.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?601742c1